import { render, staticRenderFns } from "./DashFeeProjection.vue?vue&type=template&id=166a5b2c&scoped=true&"
import script from "./DashFeeProjection.vue?vue&type=script&lang=js&"
export * from "./DashFeeProjection.vue?vue&type=script&lang=js&"
import style0 from "./DashFeeProjection.vue?vue&type=style&index=0&id=166a5b2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166a5b2c",
  null
  
)

export default component.exports